import module from 'module';
import './pawn-product-general.style.less';

const templateUrl = require('./pawn-product-general.template.html');

class PawnProductGeneralForm {
  constructor(pawnTagCache, pawnProductsCache) {
    this.pawnTagCache = pawnTagCache;
    this.pawnProductsCache = pawnProductsCache
  }

  async $onInit() {
    const [tags, pawnProducts] = await Promise.all([
      this.pawnTagCache.toPromise(),
      this.pawnProductsCache.toPromise()
    ]);

    if (!this.pawnProduct || !this.pawnProduct.id) {
      pawnProducts.unshift({
        id: -1,
        productDefinition: {
          productName: "This"
        }
      });
    }

    this.tags = tags;
    this.pawnProducts = pawnProducts;

    this.termIntervals = [
      {
        value: 'DAILY',
        label: 'Daily'
      },
      {
        value: 'MONTHLY',
        label: 'Monthly'
      }
    ];
  }

  getTermIntervalAppendLabel() {
    return this.pawnProduct.termInterval === 'DAILY' ? 'days' : 'months';
  }
}

module.component('pawnProductGeneralForm', {
  templateUrl,
  bindings: {
    pawnProduct: '=',
    form: '=',
    createMode: '<',
    branches: '<',
    pawnItemCategories: '<'
  },
  controller: PawnProductGeneralForm
});